import script from "./BaseColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./BaseColorPicker.vue?vue&type=style&index=0&id=737f25fa&lang=css"
import "./BaseColorPicker.vue?vue&type=style&index=1&id=737f25fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737f25fa"]])

export default __exports__